function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import BufferParameters from './BufferParameters';
import Position from '../../geomgraph/Position';
import Coordinate from '../../geom/Coordinate';
import BufferInputLineSimplifier from './BufferInputLineSimplifier';
import CoordinateArrays from '../../geom/CoordinateArrays';
import OffsetSegmentGenerator from './OffsetSegmentGenerator';
var OffsetCurveBuilder = /*#__PURE__*/function () {
  function OffsetCurveBuilder() {
    _classCallCheck(this, OffsetCurveBuilder);
    OffsetCurveBuilder.constructor_.apply(this, arguments);
  }
  return _createClass(OffsetCurveBuilder, [{
    key: "getOffsetCurve",
    value: function getOffsetCurve(inputPts, distance) {
      this._distance = distance;
      if (distance === 0.0) return null;
      var isRightSide = distance < 0.0;
      var posDistance = Math.abs(distance);
      var segGen = this.getSegGen(posDistance);
      if (inputPts.length <= 1) {
        this.computePointCurve(inputPts[0], segGen);
      } else {
        this.computeOffsetCurve(inputPts, isRightSide, segGen);
      }
      var curvePts = segGen.getCoordinates();
      if (isRightSide) CoordinateArrays.reverse(curvePts);
      return curvePts;
    }
  }, {
    key: "computeSingleSidedBufferCurve",
    value: function computeSingleSidedBufferCurve(inputPts, isRightSide, segGen) {
      var distTol = this.simplifyTolerance(this._distance);
      if (isRightSide) {
        segGen.addSegments(inputPts, true);
        var simp2 = BufferInputLineSimplifier.simplify(inputPts, -distTol);
        var n2 = simp2.length - 1;
        segGen.initSideSegments(simp2[n2], simp2[n2 - 1], Position.LEFT);
        segGen.addFirstSegment();
        for (var i = n2 - 2; i >= 0; i--) {
          segGen.addNextSegment(simp2[i], true);
        }
      } else {
        segGen.addSegments(inputPts, false);
        var simp1 = BufferInputLineSimplifier.simplify(inputPts, distTol);
        var n1 = simp1.length - 1;
        segGen.initSideSegments(simp1[0], simp1[1], Position.LEFT);
        segGen.addFirstSegment();
        for (var _i = 2; _i <= n1; _i++) {
          segGen.addNextSegment(simp1[_i], true);
        }
      }
      segGen.addLastSegment();
      segGen.closeRing();
    }
  }, {
    key: "computeRingBufferCurve",
    value: function computeRingBufferCurve(inputPts, side, segGen) {
      var distTol = this.simplifyTolerance(this._distance);
      if (side === Position.RIGHT) distTol = -distTol;
      var simp = BufferInputLineSimplifier.simplify(inputPts, distTol);
      var n = simp.length - 1;
      segGen.initSideSegments(simp[n - 1], simp[0], side);
      for (var i = 1; i <= n; i++) {
        var addStartPoint = i !== 1;
        segGen.addNextSegment(simp[i], addStartPoint);
      }
      segGen.closeRing();
    }
  }, {
    key: "computeLineBufferCurve",
    value: function computeLineBufferCurve(inputPts, segGen) {
      var distTol = this.simplifyTolerance(this._distance);
      var simp1 = BufferInputLineSimplifier.simplify(inputPts, distTol);
      var n1 = simp1.length - 1;
      segGen.initSideSegments(simp1[0], simp1[1], Position.LEFT);
      for (var i = 2; i <= n1; i++) {
        segGen.addNextSegment(simp1[i], true);
      }
      segGen.addLastSegment();
      segGen.addLineEndCap(simp1[n1 - 1], simp1[n1]);
      var simp2 = BufferInputLineSimplifier.simplify(inputPts, -distTol);
      var n2 = simp2.length - 1;
      segGen.initSideSegments(simp2[n2], simp2[n2 - 1], Position.LEFT);
      for (var _i2 = n2 - 2; _i2 >= 0; _i2--) {
        segGen.addNextSegment(simp2[_i2], true);
      }
      segGen.addLastSegment();
      segGen.addLineEndCap(simp2[1], simp2[0]);
      segGen.closeRing();
    }
  }, {
    key: "computePointCurve",
    value: function computePointCurve(pt, segGen) {
      switch (this._bufParams.getEndCapStyle()) {
        case BufferParameters.CAP_ROUND:
          segGen.createCircle(pt);
          break;
        case BufferParameters.CAP_SQUARE:
          segGen.createSquare(pt);
          break;
      }
    }
  }, {
    key: "getLineCurve",
    value: function getLineCurve(inputPts, distance) {
      this._distance = distance;
      if (distance < 0.0 && !this._bufParams.isSingleSided()) return null;
      if (distance === 0.0) return null;
      var posDistance = Math.abs(distance);
      var segGen = this.getSegGen(posDistance);
      if (inputPts.length <= 1) {
        this.computePointCurve(inputPts[0], segGen);
      } else {
        if (this._bufParams.isSingleSided()) {
          var isRightSide = distance < 0.0;
          this.computeSingleSidedBufferCurve(inputPts, isRightSide, segGen);
        } else this.computeLineBufferCurve(inputPts, segGen);
      }
      var lineCoord = segGen.getCoordinates();
      return lineCoord;
    }
  }, {
    key: "getBufferParameters",
    value: function getBufferParameters() {
      return this._bufParams;
    }
  }, {
    key: "simplifyTolerance",
    value: function simplifyTolerance(bufDistance) {
      return bufDistance * this._bufParams.getSimplifyFactor();
    }
  }, {
    key: "getRingCurve",
    value: function getRingCurve(inputPts, side, distance) {
      this._distance = distance;
      if (inputPts.length <= 2) return this.getLineCurve(inputPts, distance);
      if (distance === 0.0) {
        return OffsetCurveBuilder.copyCoordinates(inputPts);
      }
      var segGen = this.getSegGen(distance);
      this.computeRingBufferCurve(inputPts, side, segGen);
      return segGen.getCoordinates();
    }
  }, {
    key: "computeOffsetCurve",
    value: function computeOffsetCurve(inputPts, isRightSide, segGen) {
      var distTol = this.simplifyTolerance(this._distance);
      if (isRightSide) {
        var simp2 = BufferInputLineSimplifier.simplify(inputPts, -distTol);
        var n2 = simp2.length - 1;
        segGen.initSideSegments(simp2[n2], simp2[n2 - 1], Position.LEFT);
        segGen.addFirstSegment();
        for (var i = n2 - 2; i >= 0; i--) {
          segGen.addNextSegment(simp2[i], true);
        }
      } else {
        var simp1 = BufferInputLineSimplifier.simplify(inputPts, distTol);
        var n1 = simp1.length - 1;
        segGen.initSideSegments(simp1[0], simp1[1], Position.LEFT);
        segGen.addFirstSegment();
        for (var _i3 = 2; _i3 <= n1; _i3++) {
          segGen.addNextSegment(simp1[_i3], true);
        }
      }
      segGen.addLastSegment();
    }
  }, {
    key: "getSegGen",
    value: function getSegGen(distance) {
      return new OffsetSegmentGenerator(this._precisionModel, this._bufParams, distance);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return OffsetCurveBuilder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "copyCoordinates",
    value: function copyCoordinates(pts) {
      var copy = new Array(pts.length).fill(null);
      for (var i = 0; i < copy.length; i++) {
        copy[i] = new Coordinate(pts[i]);
      }
      return copy;
    }
  }]);
}();
export { OffsetCurveBuilder as default };
OffsetCurveBuilder.constructor_ = function () {
  this._distance = 0.0;
  this._precisionModel = null;
  this._bufParams = null;
  var precisionModel = arguments[0];
  var bufParams = arguments[1];
  this._precisionModel = precisionModel;
  this._bufParams = bufParams;
};